export default {
  fa1867274c620cab693b19300a45ddaa: 'Product information exposure',
  '3e89518163a3351ffe9c3b45eb79c1e7': 'I have purchased this product',
  '05ab0a36affc1175c16fab9076748722': 'Product Details page - SKU Selection drawer',
  '4996955f4fc9a910a791be31c7a0472a': 'Product details page - SKU Selection drawer - OK button',
  '92de5d8d5ec05a369b92feb778ac1ad6':
    'On the product details page - SKU selection drawer - Select the subscription mode',
  '9534aec7cb47306b9d4b998bb93552a0': 'Marketing Mall',
  '1f6b456ffcd1373bf6051e0294229dc4':
    'This product is temporarily unavailable for purchase. Please contact customer service',
  '952b517752a3d54632a5640bd983e3db': 'Failed to claim the coupon. Please try again later',
  '94cf66d520636599442ae580f655732e': 'List',
  a3e40f84213811f2a5420230554d3dc5: 'Has been taken off the shelves',
  c966a45e7226d9eee149a7d5f542be9f: 'Log in to view offers',
  '29a0c08714a4c60d760cd5bf677ebc57': 'No reservation qualification available for the time being',
  fc4cb54ebbbc715d113476129bb4c0b8: 'The reservation has not started yet.',
  df87923079d7c0beb2c4559579a85862: 'Will',
  ab9e4d1819317951394a1316fcf79a76: 'Start booking',
  '88d0e2a03b050f0e0a8b13fec60ffe78': 'On sale',
  '3b0d4aa3dda61c76b8217fb7b8a78966': 'About to go on sale',
  f1a8ca0bf5adda5ba15f7ddad58c2346: 'Successful reservation',
  '1d2d66fef8bf1d9bc256e789a97c566d': 'Reservation failed',
  '0ec92c3187b7485cf5ec346e5c1ccd75': 'Book now',
  '1f3807f10bd3a5cd55a044733c9c0996': 'Already available',
  '261622ea4a29c8f12e789b844fc405b1': 'The reservation was successful.',
  '416fefbd19825f08b791241e7edd6a51': 'Product Details page - Reservation Event',
  '3fb081aab838be9abd808e7a19a45c56': 'Buy now',
  '162396af34628a10c00e1b1644110716':
    'This product is a limited-purchase item. You do not meet the purchase limit conditions and thus cannot make a purchase',
  '669641b519d1f9bf11ded3320a76f079': 'Only left',
  c64a99d7afe2453355628b9b0dff433e: 'day',
  '4c848c2101c0737bf8f0fb1e54e04130': 'It has been snapped up.',
  e1e95652c564a2883bff1f99121934d8: 'Not yet started',
  '86e47c5015f810ab093752bccbc4b791': "It's over",
  e812cd2beffffe788e963984841d39d0: 'All sold out',
  f1e03e04de7143d17e58d507dcc16e1a: '"Snatched"',
  '0283ca891df8ff2d91fad9917d24c699': 'Remaining',
  '992f734b9ab6402aabe9863b1cf9d58d': 'Product detail page - Purchase button',
  '9a4d0400ff2d75d257318a86200a884a': '"Buy now"',
  '26a625c871b5730a5028ee65d0ebbd18': 'I am not eligible to go and obtain it for the time being',
  '24b7cd62ef456f2c6f81908615a85c1c': 'There is no qualification for redemption for the time being',
  e52ccbf0173ff6095d2b955c58bb6b85: 'Sold out',
  df10c47ea53f3644cb9b3995c8def019: 'Purchase separately',
  '2abe7f76b1ef67ef9d1a3bbe2afe0a1f': 'Initiate group buying',
  ce545df1de3e9f821aa842fb8f580ce8: 'If the growth beans are insufficient, get them immediately',
  '508db4afefb61cd38af412b31874d4ea': 'The balance of growth beans is insufficient',
  b75075febe9e4b01de53c0e39e243cc4: 'Shopping cart button',
  '1a47a6da484d3058d0974301171a0370': 'Product Detail page',
  ffaf8d4f12b89ab2c9866ccf84583b14: 'Shopping cart',
  c79163cb21cc27322b50bb6e22090275: 'Add to Cart',
  '168d94052e4771724dca6bf540390822': 'Select product',
  '47688c2ad210c848d5368bc8917935af': 'Limited-time flash sale',
  '4add70c59aaa6fff4f563d7b0abb9806': 'Free to claim',
  '118083967c1501a3ba4ed8f90f48f579': 'Exchange now',
  '66c4341dd5a6ce1ac4abb0346c078042': 'Only to go on sale',
  '9e178372463647f75cea572b82ec5034': '{day}天 {hour}:{minute}:{second}',
  ef8e7256d8e3cc00087df4b450c4c0b4: 'MM Month DD Day HH:mm',
  e9695eac45fefc77f14677ddc3639210: 'Over',
  bbb9cf1247041e89c64d0b04b0264cc5: 'Successfully added to the shopping cart',
  '895f1ed7be4a2dff52b3ec47edc3de8a': 'Failed to add to the shopping cart',
  '1c32ef03d1544e96db89fedc7afa1114': 'Has been reduced',
  e64983c2cf4b6d4461e4c404bdc066be: 'Please select a product',
  '4b408e8c9aff77497db39c805e591284': 'Get Coupon & Buy',
  '4e1c895fd1d75219af8bf261ac3fbf02': 'Sure',
  ac0b38c4e4a83be646db377c09d38e76: 'Parameter error!',
  '281cc99bc680ecf1a58bed226a39951b': 'Click to play the video',
  '223b5a41656ee568204b0c862266a5c3': 'Share',
  d045167754a45367b1884ad0acfbbd90: '"Delivery',
  a855b1dba6164b6c42d62bec1e575cb5: 'Express delivery',
  '91e48cde1965d26b4388fad2e07ffd3e': 'Explanation',
  '6f576b416c5f5471bedae323ba304c71': 'Product detail page - Customer service button',
  fb5bbf467b0d4d15adf84492055bbba7: 'Chat',
  c1fea370ae50c6fbc27e520df63e0dd2: 'Applicable to',
  c1a324ab0a445f9b5fcfe71c9eec0133:
    'Product Details page - SKU Selection drawer - Select the product',
  '0fc3286efd4cafb5a59ed10930a07a6b': 'Purchase quantity',
  ec1639bb0872bc4e2b7da0c93c1974e6: 'Go and check',
  '887c3e401e47568d2322008ccac1dd58':
    'You have participated in the group buying activity. Click the button below to check the progress of the group buying',
  a3eceb8e20af5c8a867d2ca0380f3458:
    'The retention pop-up window on the product detail page has been exposed',
  '6b908a8532c15fb1d35be87e33894c87': '"Mall"',
  d317e2c21b292b6d885ad97e0279592d:
    'Click the button to retain the pop-up window content on the product detail page',
  '07f53e3f4a29c2469498c84d8084415f': 'Others',
  bd48cd45b8b0cf763d9d1e752459921b:
    'Click the button at the bottom of the retention pop-up window on the product detail page'
};
